import React, { Component } from 'react';
import AWS from 'aws-sdk';
import { persistStore } from 'redux-persist';
import { CookiesProvider } from 'react-cookie';
import {
  ApolloClient,
  ApolloProvider,
  createNetworkInterface,
} from 'react-apollo';

import AWSOps, { appConfig } from '../config/AWSOps';
import App from './App';
import { getValueFromPartialKey, getKeyFromString, setValue } from '../utils/localStorageManager'
import configureStore from '../store';
import domains from './Domains';

const store = configureStore();

const awsURI = (domains[window.location.hostname]) ? domains[window.location.hostname] : domains["localhost"];

export default class Root extends Component {
  state = { rehydrated: false, loggedIn: false };

  componentWillMount() {
    persistStore(store, { whitelist: ['user', 'fbuser'] }, () => {
      this.setState({ rehydrated: true, loggedIn: store.getState().user.loggedIn });
    });
  }

  createClient = () => {
    const that = this;
    let idToken = getValueFromPartialKey('idToken');

    const networkInterface = createNetworkInterface({
      uri: `${awsURI}graphql`,
      dataIdFromObject: o => o.id,
      connectToDevTools: process.env.NODE_ENV === 'development',
      opts: {
        headers: {
          AlexiaAuth: idToken,
        },
      },
    });

    networkInterface.use([{
      applyMiddleware(req, next) {
        const tokenLastUpdate = getValueFromPartialKey('tokenLastUpdate');

        if (tokenLastUpdate !== 'null') {
          const lastDate = new Date(tokenLastUpdate);
          const currentDate = new Date();
          const diff = Math.abs(currentDate - lastDate);
          const minutes = Math.floor((diff / 1000) / 60);

          if (minutes >= 30) {
            const refreshToken = getValueFromPartialKey('refreshToken');

            if (!refreshToken) {
              that.logout();
            }

            AWS.config.update({ region: 'us-east-1', accessKeyId: 'accessKeyId', secretAccessKey: 'secretAccessKey' });

            const awsService = new AWS.CognitoIdentityServiceProvider();
            awsService.initiateAuth(that.getAuthParams(refreshToken), (err, data) => {
              if (err) {
                that.logout();
              }

              if (data) {
                that.updateTokens(data);
                req.options.headers['AlexiaAuth'] = data.AuthenticationResult.IdToken;
                next();
              }
            });
          } else {
            next();
          }
        } else {
          next();
        }
      }
    }]);

    networkInterface.useAfter([{
      applyAfterware({ response }, next) {
        if (response.status === 401) {
          that.refreshToken();
        }

        next();
      },
    }]);

    const client = new ApolloClient({
      connectToDevTools: true,
      networkInterface,
    });

    return client;
  }

  getAuthParams = (refreshToken) => {
    const authParams = {
      AuthFlow: 'REFRESH_TOKEN_AUTH',
      ClientId: appConfig.ClientId,
      AuthParameters: {
        REFRESH_TOKEN: refreshToken,
      },
      ClientMetadata: {},
    };

    return authParams;
  }

  updateTokens = (data) => {
    setValue(getKeyFromString('tokenLastUpdate'), new Date());
    setValue(getKeyFromString('accessToken'), data.AuthenticationResult.AccessToken);
    setValue(getKeyFromString('idToken'), data.AuthenticationResult.IdToken);
    AWSOps.config.credentials = new AWSOps.CognitoIdentityCredentials({
      IdentityPoolId: appConfig.IdentityPoolId,
      Logins: { [appConfig.LoginId]: data.AuthenticationResult.IdToken },
    });
  }

  userLogged = () => {
    this.setState({ loggedIn: store.getState().user.loggedIn });
  }

  logout = () => {
    localStorage.clear();
    window.location.replace('/login');
  }

  refreshToken = () => {
    const refreshToken = getValueFromPartialKey('refreshToken');

    if (!refreshToken) {
      this.logout();
    }

    AWS.config.update({ region: 'us-east-1', accessKeyId: 'accessKeyId', secretAccessKey: 'secretAccessKey' });

    const awsService = new AWS.CognitoIdentityServiceProvider();
    awsService.initiateAuth(this.getAuthParams(refreshToken), (err, data) => {
      if (err) {
        this.logout();
      }

      if (data) {
        this.updateTokens(data);
        window.location.reload();
      }
    });
  }

  renderApp = () => {
    const isLoggedIn = this.state.loggedIn;
    let client;

    try {
      client = this.createClient();
    } catch (ex) {
      this.refreshToken();
    }

    const shareLinks = '/presentations/detail/';
    const importShareLinks = '/presentationsImport/detail/';
    const currentURL = window.location.href;
    const isShareLinks = (currentURL.indexOf(shareLinks) !== -1);
    const isImportShareLinks = (currentURL.indexOf(importShareLinks) !== -1);

    if (isLoggedIn || isShareLinks || isImportShareLinks) {
      return (
        <CookiesProvider>
          <ApolloProvider store={store} client={client}>
            <App userLogged={this.userLogged} refreshToken={this.refreshToken} />
          </ApolloProvider>
        </CookiesProvider>
      );
    }
    return (
      <ApolloProvider store={store} client={client}>
        <App userLogged={this.userLogged} refreshToken={this.refreshToken} />
      </ApolloProvider>
    );
  }

  render() {
    if (!this.state.rehydrated) {
      return (
        <div>
          <p>Rehydrating</p>
        </div>
      );
    }
    return (
      <div>{this.renderApp()}</div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/containers/Root.js